import { bool, number, object, string } from "yup";
import PaymentPeriod from "../../common/interfaces/enums/PaymentPeriod";
import { IIncomeQuoteClient } from "../interfaces/form/income/IIncomeQuoteClient";
import { IQuoteClient } from "../interfaces/form/IQuoteClient";
import { isSelected } from "./ValidationHelpers";

const client = object<IIncomeQuoteClient>({
    isSelected: bool().notRequired().default(false),
    monthlyCover: isSelected(
        number(),
        number()
            .positive("Please provide a monthly cover amount")
            .required("Please provide a monthly cover amount")
    ),
    paymentPeriod: isSelected(
        string<PaymentPeriod>(),
        string<PaymentPeriod>().required("Please select a payment period")
    ),
    waitPeriodWeeks: isSelected(
        number(),
        number().required("Please select a wait period")
    )
}).test(
    "test-monthly-cover-vs-income",
    "Monthly cover can be up to 75% of your monthly income",
    function (income) {
        const parent: IQuoteClient = this.parent;
        // If the parent isn't selected, we don't evaluate
        if (!income.isSelected) return true;
        const monthlyIncome = parent.occupation?.income / 12;
        const maxCoverAmount = Math.ceil(monthlyIncome * 0.75);
        return income.monthlyCover <= maxCoverAmount;
    }
);

export default { client };
